import { useState } from 'react';
import { Badge, Card, Tabs } from 'antd';
import HeadingTypography from 'src/app/components/shared/Typography/Heading';
import { useLeadContext } from '@contexts';
import { LeadsTable } from 'src/app/components/shared/LeadsTable/LeadsTable';
import { LeadGurators } from 'src/app/components/shared';

const LeadTableCard = () => {
    const { holdLeadsData, setLeadsFiltars, leadsFiltars, dropofLeadsFiltars, setDropofLeadsFiltars, holdLeadsFiltars, setHoldLeadsFiltars } = useLeadContext();
    const [activeTab, setActiveTab] = useState('1');
    const [allLeadsCount, setAllLeadsCount] = useState('');
    const [holdLeadsCount, setHoldLeadsCount] = useState('');

    return (
        <div className="pt-4 bg-gray-100 rounded-lg">
            <Card>
                <div className="border-2 border-black rounded-lg overflow-visible">
                    <Tabs
                        defaultActiveKey="1"
                        onChange={key => setActiveTab(key)}
                        tabBarStyle={{ borderBottom: '1px solid #d9d9d9', display: 'flex', alignItems: 'center', overflow: 'visible' }}
                        className="text-lg tabs-custom-style "
                    >
                        <Tabs.TabPane
                            key="1"
                            tab={
                                <>
                                    <Badge count={allLeadsCount} className="flex items-center" style={{ top: 'unset' }}>
                                        <HeadingTypography fontSize={16} classNames={`flex items-center h-[40px] px-[20px] ${activeTab !== '1' ? '!font-light text-gray-400 text-[#DBD7D7]' : ''}`}>
                                            All Leads
                                        </HeadingTypography>
                                    </Badge>
                                    {activeTab === '1' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#FCD4D6]" />}
                                </>
                            }
                        >
                            {activeTab === '1' ? (
                                <LeadsTable
                                    tabKey={'1'}
                                    activeTab={activeTab}
                                    savedFilters={leadsFiltars}
                                    setSavedFilters={setLeadsFiltars}
                                    actions={true}
                                    setCount={setAllLeadsCount}
                                    tableType="allLeads"
                                    isAddButton={true}
                                    optionalColumns={['all']}
                                    optionalActions={['edit', 'view', 'plan', 'credit']}
                                    getHoldDataOnInitialRender={true}
                                />
                            ) : null}
                        </Tabs.TabPane>

                        <Tabs.TabPane
                            key="2"
                            tab={
                                <>
                                    <Badge count={holdLeadsData.count || holdLeadsCount} className="flex items-center" style={{ top: 'unset' }}>
                                        <HeadingTypography fontSize={16} classNames={`flex items-center h-[40px] px-[20px] ${activeTab !== '2' ? '!font-light text-gray-400 text-[#DBD7D7]' : ''}`}>
                                            Hold
                                        </HeadingTypography>
                                    </Badge>
                                    {activeTab === '2' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#FCD4D6]" />}
                                </>
                            }
                        >
                            {activeTab === '2' ? (
                                <LeadsTable
                                    tabKey={'2'}
                                    activeTab={activeTab}
                                    savedFilters={holdLeadsFiltars}
                                    setSavedFilters={setHoldLeadsFiltars}
                                    actions={true}
                                    setCount={setHoldLeadsCount}
                                    tableType="holdLeads"
                                    isAddButton={true}
                                    optionalColumns={['all']}
                                    optionalActions={['edit', 'view', 'plan', 'reasignCredit']}
                                />
                            ) : null}
                        </Tabs.TabPane>

                        <Tabs.TabPane
                            key="3"
                            tab={
                                <>
                                    <div className="flex items-center h-[40px]">
                                        <HeadingTypography fontSize={16} classNames={`flex items-center h-[40px] px-[20px] ${activeTab !== '3' ? '!font-light text-gray-400 text-[#DBD7D7]' : ''}`}>
                                            Drop-off
                                        </HeadingTypography>
                                    </div>
                                    {activeTab === '3' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#FCD4D6]" />}
                                </>
                            }
                        >
                            {activeTab === '3' ? (
                                <LeadsTable
                                    tabKey={'3'}
                                    activeTab={activeTab}
                                    savedFilters={dropofLeadsFiltars}
                                    setSavedFilters={setDropofLeadsFiltars}
                                    actions={false}
                                    tableType="dropOfLeads"
                                    isAddButton={true}
                                    optionalColumns={['all']}
                                />
                            ) : null}
                        </Tabs.TabPane>

                        <Tabs.TabPane
                            key="4"
                            tab={
                                <>
                                    <div className="flex items-center h-[40px]">
                                        <HeadingTypography fontSize={16} classNames={`flex items-center h-[40px] px-[20px] ${activeTab !== '4' ? '!font-light text-gray-400 text-[#DBD7D7]' : ''}`}>
                                            Guarantors
                                        </HeadingTypography>
                                    </div>
                                    {activeTab === '4' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#FCD4D6]" />}
                                </>
                            }
                        >
                            <LeadGurators activeTab={activeTab} />
                        </Tabs.TabPane>
                    </Tabs>
                </div>
            </Card>
        </div>
    );
};

export default LeadTableCard;
